import { useEffect, useState } from "react";
import { TextInput, CloseButton } from "@mantine/core";
import { IconSearch } from "@tabler/icons-react";

interface ApartmentSearchProps {
  value: string;
  onChange: (value: string) => void;
}

export function ApartmentSearch({ value, onChange }: ApartmentSearchProps) {
  const [localValue, setLocalValue] = useState(value);

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (localValue !== value) {
        onChange(localValue);
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [localValue, value, onChange]);

  return (
    <TextInput
      flex={1}
      placeholder="Search apartments..."
      value={localValue}
      onChange={(e) => setLocalValue(e.currentTarget.value)}
      leftSection={<IconSearch size={18} color="#888888" />}
      rightSection={
        localValue ? (
          <CloseButton
            size="sm"
            onClick={() => {
              setLocalValue("");
              onChange("");
            }}
          />
        ) : null
      }
      styles={{
        input: {
          backgroundColor: "#16213e",
          borderColor: "#0f3460",
        },
      }}
    />
  );
}
